import { fromClientToFrame } from '@/clientFrameEvents';

export default (iframe, uuid) => {
  function send(messageName, payload) {
    iframe.contentWindow.postMessage({
      messageName,
      ...payload,
    }, '*');
  }

  const callbacks = {
    created: [],
    syncSize: [],
    inited: [],
    orderCreated: [],
    sendTheme: [],
    sendLanguage: [],
    sendPaymentData: [],
    sendOrderFromBalanceCreated: [],
    sendOrderFromLinkedCardCreated: [],
  };

  const api = {
    init: (initConfig) => send(fromClientToFrame.init, initConfig),
    onSyncSize: (cb) => callbacks.syncSize.push(cb),
    onOrderCreated: (cb) => callbacks.orderCreated.push(cb),
    onInited: (cb) => callbacks.inited.push(cb),
    onCreated: (cb) => callbacks.created.push(cb),
    getTheme: () => new Promise((resolve) => {
      const onSendTheme = ({ theme }) => {
        callbacks.sendTheme.splice(
          callbacks.sendTheme.indexOf(onSendTheme),
          1,
        );

        resolve(theme);
      };
      callbacks.sendTheme.push(onSendTheme);
      send(fromClientToFrame.getTheme);
    }),
    setTheme: (theme) => send(fromClientToFrame.setTheme, { theme }),
    getLanguage: () => new Promise((resolve) => {
      const onSendLanguage = ({ language }) => {
        callbacks.sendLanguage.splice(
          callbacks.sendLanguage.indexOf(onSendLanguage),
          1,
        );

        resolve(language);
      };
      callbacks.sendLanguage.push(onSendLanguage);
      send(fromClientToFrame.getLanguage);
    }),
    setLanguage: (language) => send(fromClientToFrame.setLanguage, { language }),
    onPaymentData: (cb) => callbacks.sendPaymentData.push(cb),
    onOrderFromBalanceCreated: (cb) => callbacks.sendOrderFromBalanceCreated.push(cb),
    onOrderFromLinkedCardCreated: (cb) => callbacks.sendOrderFromLinkedCardCreated.push(cb),
    destroy: () => iframe.remove(),
    createCartItem(config) {
      send(fromClientToFrame.createCartItem, { config });
    },
  };

  window.addEventListener('message', (event) => {
    if (!event || !event.data || !(event.data instanceof Object)) {
      return;
    }

    const { messageName, ...payload } = event.data;

    if (event.data.uuid !== String(uuid)) {
      return;
    }

    callbacks[messageName].forEach((cb) => cb(payload));
  }, false);

  return api;
};
